/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebfieldphone3Inputs */

const en_placewebfieldphone3 = /** @type {(inputs: Placewebfieldphone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone`)
};

const de_placewebfieldphone3 = /** @type {(inputs: Placewebfieldphone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

/**
* | output |
* | --- |
* | "Phone" |
*
* @param {Placewebfieldphone3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebfieldphone3 = /** @type {((inputs?: Placewebfieldphone3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebfieldphone3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebfieldphone3(inputs)
	return de_placewebfieldphone3(inputs)
});
export { placewebfieldphone3 as "placeWebFieldPhone" }